import { useState, useEffect } from "react";
import { Sv, ic } from "../../components/common/Icons";
import api from "../../services/api";
import { resolveNotifRoute } from "../../utils/notifRouteResolver";
import "../../assets/styles/ITAdmin/ITANotificationpg.css";

function ITANotificationsPage({ onNavigate }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const data = await api.getNotifications();
      setNotifications(data || []);
    } catch (err) {
      console.warn("Failed to load notifications:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    try {
      await api.markNotificationRead(id);
      setNotifications((prev) =>
      prev.map((n) => n.id === id ? { ...n, unread: false, is_read: true } : n)
      );
    } catch (err) {
      console.warn(err.message);
    }
  };

  const markAllRead = async () => {
    try {
      await api.markAllNotificationsRead();
      setNotifications((prev) =>
      prev.map((n) => ({ ...n, unread: false, is_read: true }))
      );
    } catch (err) {
      console.warn(err.message);
    }
  };

  const deleteNotification = async (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const fmtTime = (t) => {
    if (!t) return "";
    try {
      const d = new Date(t);
      const diff = Math.floor((Date.now() - d) / 60000);
      if (diff < 1) return "Just now";
      if (diff < 60) return `${diff}m ago`;
      if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
      return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    } catch {return "";}
  };

  const typeColor = {
    helpdesk: "#6366f1",
    event: "#2563eb",
    announcement: "#f59e0b",
    leave: "#3b82f6",
    system: "#64748b"
  };

  const typeIcon = {
    helpdesk: "ticket",
    event: "calendar",
    announcement: "megaphone",
    leave: "cal",
    system: "gear"
  };

  const unreadCount = notifications.filter((n) => n.unread || !n.is_read).length;

  const filtered = filter === "all" ?
  notifications :
  filter === "unread" ?
  notifications.filter((n) => n.unread || !n.is_read) :
  notifications.filter((n) => n.type === filter);

  return (
    <div>
      {/* Header */}
      <div className="card animate-in itanotificationpg-inline-1">
        <div className="card-header itanotificationpg-inline-2">
          <div>
            <div className="card-title">Notifications</div>
            <div className="card-subtitle">{unreadCount} unread notification{unreadCount !== 1 ? "s" : ""}</div>
          </div>
          <div className="itanotificationpg-inline-3">
            {unreadCount > 0 &&
            <button
              onClick={markAllRead} className="itanotificationpg-inline-4">

              
                ✓ Mark all read
              </button>
            }
          </div>
        </div>
      </div>

      {/* Filter tabs */}
      <div className="itanotificationpg-inline-5">
        {[
        { k: "all", l: "All" },
        { k: "unread", l: `Unread (${unreadCount})` },
        { k: "helpdesk", l: "Helpdesk" },
        { k: "event", l: "Events" },
        { k: "announcement", l: "Announcements" },
        { k: "leave", l: "Leave" }].
        map((f) =>
        <button
          key={f.k}
          onClick={() => setFilter(f.k)} style={{ "--itanotificationpg-1-border":


            filter === f.k ? "1.5px solid #6366f1" : "1px solid #e2e8f0", "--itanotificationpg-1-background":
            filter === f.k ? "#eef2ff" : "#fff", "--itanotificationpg-1-color":
            filter === f.k ? "#4f46e5" : "#64748b" }} className="itanotificationpg-dyn-1">
          
          
            {f.l}
          </button>
        )}
      </div>

      {/* Notification list */}
      <div className="card animate-in">
        <div className="card-body itanotificationpg-inline-6">
          {loading ?
          <div className="itanotificationpg-inline-7">Loading notifications...</div> :
          filtered.length === 0 ?
          <div className="itanotificationpg-inline-8">
              <div className="itanotificationpg-inline-9">🔔</div>
              <div className="itanotificationpg-inline-10">No notifications</div>
              <div className="itanotificationpg-inline-11">
                {filter === "unread" ? "All caught up!" : "Nothing here yet"}
              </div>
            </div> :

          filtered.map((n, idx) => {
            const isUnread = n.unread || !n.is_read;
            const color = typeColor[n.type] || "#64748b";
            const iconKey = typeIcon[n.type] || "bell";
            return (
              <div
                key={n.id || idx}
                onClick={() => {
                  if (isUnread) markRead(n.id);
                  setSelected(n);
                  const dest = resolveNotifRoute(n, 'itadmin');
                  if (dest && onNavigate && dest !== 'notifications') {
                    setTimeout(() => onNavigate(dest), 250);
                  }
                }} style={{ "--itanotificationpg-2-background":



                  isUnread ? "#f8fafc" : "#fff", "--itanotificationpg-2-cursor":

                  isUnread ? "pointer" : "default" }} className="itanotificationpg-dyn-2">

                
                
                  {/* Icon */}
                  <div style={{ "--itanotificationpg-3-background":

                  `${color}15` }} className="itanotificationpg-dyn-3">

                  
                    <Sv d={ic[iconKey] || ic.bell} s={16} c={color} />
                  </div>

                  {/* Content */}
                  <div className="itanotificationpg-inline-12">
                    <div className="itanotificationpg-inline-13">
                      {isUnread && <div className="itanotificationpg-inline-14" />}
                      <div style={{ "--itanotificationpg-4-font-weight": isUnread ? 700 : 600, "--itanotificationpg-4-color": isUnread ? "#1e293b" : "#475569" }} className="itanotificationpg-dyn-4">
                        {n.title || n.text || "Notification"}
                      </div>
                    </div>
                    <div className="itanotificationpg-inline-15">
                      {n.body || n.message || n.text || ""}
                    </div>
                    <div className="itanotificationpg-inline-16">
                      <span className="itanotificationpg-inline-17">{fmtTime(n.time || n.created_at)}</span>
                      <span style={{ "--itanotificationpg-5-background":

                      `${color}15`, "--itanotificationpg-5-color": color }} className="itanotificationpg-dyn-5">
                      
                        {n.type || "system"}
                      </span>
                    </div>
                  </div>

                  {/* Delete */}
                  <button
                  onClick={(e) => {e.stopPropagation();deleteNotification(n.id);}}




                  title="Dismiss" className="itanotificationpg-inline-18">
                  
                    ✕
                  </button>
                </div>);

          })
          }
        </div>
      </div>
      {selected &&
      <div className="card animate-in itanotificationpg-inline-19">
          <div className="card-header">
            <div className="card-title">Notification Detail</div>
            <button onClick={() => setSelected(null)} style={{ background:"none", border:"none", fontSize:18, cursor:"pointer", color:"#94a3b8" }}>×</button>
          </div>
          <div className="card-body">
            <div className="itanotificationpg-inline-20">{selected.title || selected.text || "Notification"}</div>
            <div className="itanotificationpg-inline-21">{selected.body || selected.message || selected.text || "-"}</div>
            {selected.created_at && (
              <div style={{ fontSize:11, color:"#94a3b8", marginTop:8 }}>
                {new Date(selected.created_at).toLocaleString("en-IN")}
              </div>
            )}
            {(() => {
              const dest = resolveNotifRoute(selected, 'itadmin');
              const label = { credentials:"View Credentials", announce:"View Announcements & Evals", assets:"View Assets", requests:"View Requests", exit:"View Exit Queue", chat:"Open Chat" };
              return dest && onNavigate && dest !== "notifications" ? (
                <button
                  onClick={() => { onNavigate(dest); setSelected(null); }}
                  style={{ marginTop:12, padding:"8px 16px", background:"#4f46e5", color:"#fff", border:"none", borderRadius:8, fontWeight:700, fontSize:13, cursor:"pointer", width:"100%", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
                  → {label[dest] || `Go to ${dest}`}
                </button>
              ) : null;
            })()}
          </div>
        </div>
      }
    </div>);

}

export default ITANotificationsPage;